export default __webpack_public_path__ + "static/breadcrumbs-icons-do-dark-7a3318ed704bb82c9da7eb4f92d412bca3ed137e82b767ae25d3b459b54bf790.png";